// extracted by mini-css-extract-plugin
module.exports = {"SectionName":"index-module--SectionName--2tw8d","SurroundingText":"index-module--SurroundingText--2lRyE"};